import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const bills = () => import('./bills-pages');
const payments = () => import('./payments-pages');
const reports = () => import('./reports-pages');

// G2 (payables): supplier bills, payments out, repeating bills, aged payables. Owned by the payables module.
export const routes: RouteObject[] = [
  {
    path: 'payables',
    lazy: page(bills, (m) => m.PayablesLayout),
    children: [
      { index: true, lazy: page(bills, (m) => m.BillsPage) },
      { path: 'payments', lazy: page(payments, (m) => m.PaymentRunsPage) },
      { path: 'repeating', lazy: page(() => import('./repeating-page'), (m) => m.RepeatingPage) },
      { path: 'aged', lazy: page(reports, (m) => m.AgedPayablesPage) },
      { path: 'settings', lazy: page(() => import('./settings-page'), (m) => m.PayablesSettingsPage) },
    ],
  },
  // Detail pages open full width, outside the tabbed frame.
  { path: 'payables/bills/:id', lazy: page(() => import('./bill-detail'), (m) => m.BillDetailPage) },
  { path: 'payables/payments/:id', lazy: page(payments, (m) => m.PaymentRunPage) },
  { path: 'payables/suppliers/:vendorId/statement', lazy: page(reports, (m) => m.SupplierStatementPage) },
];

/** The Bills tab on a vendor organization. */
export const orgRoutes: RouteObject[] = [{ path: 'bills', lazy: page(() => import('./org-bills'), (m) => m.OrgBillsPage) }];
